import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0548d83c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "../node_modules/flexboxgrid/dist/flexboxgrid.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=0548d83c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports